async function refreshCartDrawer() {
  try {
    const res = await fetch("/cart?sections=cart,cart-count");
    const data = await res.json();

    const drawer = document.querySelector("cart-drawer");
    if (!drawer) {
      console.warn("Cart drawer element not found");
      return;
    }

    // Replace HTML for each section
    Object.keys(data).forEach((sectionId) => {
      const html = data[sectionId];
      const container = document.querySelector(`#${sectionId}`);

      if (container) {
        const parsed = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(`#shopify-section-${sectionId}`);

        if (parsed) container.innerHTML = parsed.innerHTML;
      }
    });
document.dispatchEvent(new CustomEvent("added:cart"));
    drawer.classList.add("active");
  } catch (err) {
    console.error("Error refreshing drawer:", err);
  }
}

function initAddToCartBox() {
  document.querySelectorAll(".ft-product-card").forEach((card) => {
    const openBtn = card.querySelector("[data-open-box]");
    const box = card.querySelector(".ft-add-box");
    const variantBtns = card.querySelectorAll(".ft-variant-btn");
    const pricesEl = card.querySelectorAll("[data-variant-price]");
    const imgEl = card.querySelector(".ft-main-img");
    const linkEl = card.querySelector(".ft-product-image-wrapper");

    /*openBtn.addEventListener("mouseover", (e) => {
      box.classList.toggle("show");
    });

    box.addEventListener("mouseleave", (e) => {
      box.classList.remove("show");
    });*/

    let variants = [];
    try {
      variants = JSON.parse(card.dataset.variants);
    } catch (e) {
      console.warn("Invalid variants JSON", e);
      return;
    }

    variantBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        variantBtns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        const variantId = btn.dataset.variantId;

        const variant = variants.find(
          (v) => String(v.id) === String(variantId)
        );

        if (!variant) return;

        //if (priceEl) priceEl.textContent = btn.dataset.price;

        pricesEl.forEach((price) => {

          if (price) price.textContent = btn.dataset.price;
        });

        if (variant.featured_image && imgEl) {
          imgEl.src = variant.featured_image.src;
          imgEl.alt = variant.featured_image.alt || "";
        }

        if (linkEl) {
          const url = new URL(linkEl.href);
          url.searchParams.set("variant", variant.id);
          linkEl.href = url.toString();
        }
        
      });
    });
  });
}

function openCartDrawer() {
  const drawer = document.querySelector("#CartDrawer");

  if (!drawer) {
    console.warn("Cart drawer not found");
    return false;
  }

  if (typeof drawer.open === "function") {
    drawer.open();
    return true;
  }


  console.warn("Drawer exists but has no .open() method");
  return false;
}

export function initAddToCartButtons() {
  document.addEventListener("click", async (e) => {
    if (!e.target.closest(".ft-add-btn")) return;

    e.preventDefault();

    const card = e.target.closest(".ft-product-card");
    const box = card.querySelector(".ft-add-box");

    let variantId = null;

    // 1) Try active variant
    const activeVariantBtn = card.querySelector(".ft-variant-btn.active");
    if (activeVariantBtn) {
      variantId = activeVariantBtn.dataset.variantId;
    } else {
      // 2) If no active, try first variant
      const firstVariant = card.querySelector(".ft-variant-btn");
      if (firstVariant) {
        variantId = firstVariant.dataset.variantId;
      } else {
        // 3) If product has only ONE variant (no buttons)
        const variantFromLiquid = card.dataset.defaultVariant;
        if (variantFromLiquid) {
          variantId = variantFromLiquid;
        } else {
          console.error("No variant found for this product.");
          return;
        }
      }
    }

    // SUBSCRIPTION CHECK
    const toggle = card.querySelector(".switch input");
    const sellingPlanDiv = card.querySelector(".ft-selling-plan");

    let sellingPlanId = null;
    if (toggle && toggle.checked && sellingPlanDiv) {
      sellingPlanId = sellingPlanDiv.dataset.sellingPlan;
    }

    // PAYLOAD
    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
        },
      ],
    };

    // ADD TO CART
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      refreshCartDrawer();
      openCartDrawer();
    } catch (err) {
      console.error(err);
    }
  });
}

/* =======================================
   MOBILE DRAWER MENU 
   ======================================= */

function initMobileDrawer(options = {}) {
  const {
    drawerSelector = "#mobile-drawer",
    hamburgerSelector = "#header-hamburger",
    closeButtonSelector = "#mobile-drawer-close",
    mainMenuSelector = "#mobile-menu-main",
    submenuSelector = ".submenu",
    backBtnSelector = "[data-back]",
    childMenuSelector = ".menu-link.has-children",
    searchBarSelector = ".mobile-drawer__search",
  } = options;

  const drawer = document.querySelector(drawerSelector);
  const hamburger = document.querySelector(hamburgerSelector);
  const closeButton = document.querySelector(closeButtonSelector);
  const overlay = drawer?.querySelector(".mobile-drawer__overlay");
  const mainMenu = document.querySelector(mainMenuSelector);
  const submenuPanels = document.querySelectorAll(submenuSelector);
  const backButtons = document.querySelectorAll(backBtnSelector);
  const childButtons = document.querySelectorAll(childMenuSelector);
  const searchBar = document.querySelector(searchBarSelector);

  /* ---------------------------
     OPEN DRAWER
  --------------------------- */
  function openDrawer() {
    drawer?.classList.add("open");
    document.body.classList.add("overflow-hidden");
  }

  /* ---------------------------
     CLOSE DRAWER
  --------------------------- */
  function closeDrawer() {
    drawer?.classList.remove("open");
    document.body.classList.remove("overflow-hidden");
    resetMenus();
  }

  /* ---------------------------
     OPEN SUBMENU
  --------------------------- */
  function openSubmenu(id) {
    if (!id) return;

    // hide main menu + search bar
    mainMenu.style.display = "none";
    searchBar.style.display = "none";

    // activate correct submenu
    const target = document.querySelector(`#submenu-${id}`);
    if (target) target.classList.add("active");
  }

  /* ---------------------------
     BACK TO MAIN MENU
  --------------------------- */
  function goBack() {
    resetMenus();
  }

  /* ---------------------------
     RESET TO MAIN MENU
  --------------------------- */
  function resetMenus() {
    submenuPanels.forEach((panel) => panel.classList.remove("active"));
    mainMenu.style.display = "block";
    searchBar.style.display = "block";
  }

  /* ---------------------------
     EVENT LISTENERS
  --------------------------- */

  // Hamburger opens drawer
  hamburger?.addEventListener("click", openDrawer);

  // Close button
  closeButton?.addEventListener("click", closeDrawer);

  // Click overlay closes drawer
  overlay?.addEventListener("click", closeDrawer);

  // Open submenus
  childButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.menu;
      openSubmenu(id);
    });
  });

  // Back buttons
  backButtons.forEach((btn) => {
    btn.addEventListener("click", goBack);
  });

  return {
    openDrawer,
    closeDrawer,
    openSubmenu,
    goBack,
  };
}

function initDrawerMegaMenu() {
  /* ---------------------------
   * ACCORDION
   * --------------------------- */
  const triggers = document.querySelectorAll(".drawer-accordion-trigger");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const targetId = trigger.dataset.accordion;
      const content = document.getElementById(targetId);
      const isOpen = trigger.classList.contains("open");

      // Close all triggers
      document.querySelectorAll(".drawer-accordion-trigger").forEach((t) => {
        t.classList.remove("open");
      });

      // Close all contents
      document.querySelectorAll(".drawer-accordion-content").forEach((c) => {
        c.classList.remove("open");
      });

      // Toggle the clicked one
      if (!isOpen) {
        trigger.classList.add("open");
        content.classList.add("open");
      }
    });
  });

  /* ---------------------------
   * BEST SELLER PANELS
   * --------------------------- */
  const bestSellerBtns = document.querySelectorAll(".kb-best-seller-trigger");
  const bestSellerPanels = document.querySelectorAll(".kb-bestseller-panel");
  const linksBlock = document.querySelector(".kb-links-mobile");
  const sliderBlock = document.querySelector(".kb-slider-mobile");

  bestSellerBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.bestsellerPanel;
      const panel = document.getElementById(id);

      // Hide all parent content
      linksBlock.style.display = "none";
      sliderBlock.style.display = "none";

      // Show the panel
      panel.classList.add("open");
    });
  });

  /* ---------------------------
   * BACK BUTTON
   * --------------------------- */
  document.querySelectorAll("[data-bestseller-back]").forEach((btn) => {
    btn.addEventListener("click", () => {
      // Close best seller panel
      bestSellerPanels.forEach((panel) => panel.classList.remove("open"));

      // Show parent menu
      linksBlock.style.display = "flex";
      sliderBlock.style.display = "flex";
    });
  });
}



function getBogosValidGifts() {
  if (!window.FGSECOMAPP?.offers) return [];

  return FGSECOMAPP.offers.flatMap((offer) =>
    (offer.gift_items || []).map((item) => ({
      ...item,
      variants: [
        {
          variant_shopify_id: item.variant_shopify_id,
        },
      ],
    }))
  );
}


function getGiftsFromPopup() {
  const popup = document.querySelector("#freegifts-main-popup-container");
  if (!popup) return [];

  const items = popup.querySelectorAll(
    ".bogos-gift-items .glider-track .product-item"
  );

  return Array.from(items).map(item => {
    const btn = item.querySelector(".btn-add-to-cart");
    if (!btn) return null;

    return {
      offerId: btn.dataset.offer,
      variantId: btn.dataset.variant
    };
  }).filter(Boolean);
}

function getFilteredBogosGifts() {
  const allGifts = getBogosValidGifts();        
  const popupGifts = getGiftsFromPopup();     

  if (!popupGifts.length) return [];

  return allGifts.filter(gift => {
    const variant = gift.variants?.[0];
    if (!variant) return false;

    return popupGifts.some(
       p => String(p.variantId) === String(variant.variant_shopify_id) ||
       String(p.productId) === String(gift.product_shopify_id)
    );

  });
}




function renderBogosGiftSlider() {
  const container = document.querySelector("[data-bogos-gifts]");
  if (!container) return;

  const swiperEl = container.querySelector("[js-carousel]");
  const wrapper = swiperEl?.querySelector(".swiper-wrapper");

  const gifts = getFilteredBogosGifts();

  // Always clear before re-render
  if (wrapper) wrapper.innerHTML = "";

  // Render slides if gifts exist
  if (Array.isArray(gifts)) {
    wrapper.innerHTML = gifts.map(gift => {
      if (!gift) return "";

      const variantId = gift.variant_shopify_id;
      const offerId = gift.pivot?.offer_id;
      const title = gift.gift_product?.title;
      const thumbnail = gift.thumbnail || gift.gift_product?.thumbnail || "";

      return `
        <div class="swiper-slide">
          <div class="gift-card">
            <div class="gift-image">
              <img src="${thumbnail}" alt="${title}">
            </div>

            <div class="gift-info">
              <span class="gift-category">FREE SAMPLE</span>
              <h4 class="gift-title">${title}</h4>
            </div>

            <button
              class="bogos-gift-add-btn recommendation-button"
              type="button"
              data-variant-id="${variantId}"
              data-offer-id="${offerId}"
            >
              ADD
            </button>
          </div>
        </div>
      `;
    }).join("");
  }

  /* ----------------------------------
     FINAL VISIBILITY LOGIC (ALWAYS)
  ---------------------------------- */

  const hasSlides = wrapper.querySelectorAll(".swiper-slide").length > 0;

  if (!hasSlides) {
    if (swiperEl?.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
    container.style.display = "none";
    return;
  }

  container.style.display = "grid";

  // Re-init swiper safely
  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    autoHeight: true,
    grabCursor: true,
    pagination: {
      el: ".gift-pagination",
      type: "bullets",
      clickable: true
    },
    navigation: {
      nextEl: ".gift-next",
      prevEl: ".gift-prev"
    }
  });
}


function observeBogosPopup() {
  const popup = document.querySelector("#freegifts-main-popup-container");
  if (!popup) return;

  const observer = new MutationObserver(() => {
    renderBogosGiftSlider();
  });

  observer.observe(popup, {
    childList: true,
    subtree: true
  });

  // Initial render
  renderBogosGiftSlider();
}

function observeBogosSlider() {
  const container = document.querySelector("[data-bogos-gifts]");
  if (!container) return;

  const swiperEl = container.querySelector("[js-carousel]");
  const wrapper = swiperEl?.querySelector(".swiper-wrapper");
  if (!wrapper) return;

  const toggleVisibility = () => {
    const hasSlides = wrapper.querySelectorAll(".swiper-slide").length > 0;

    if (!hasSlides) {
      console.log("NO SLIDES");
      if (swiperEl?.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      container.style.display = "none";
    } else {
      container.style.display = "grid";
    }
  };

  
  toggleVisibility();

  const observer = new MutationObserver(toggleVisibility);

  observer.observe(wrapper, {
    childList: true,
    subtree: false
  });
}

function whenRebuyHasChildren(
  rebuySelector,
  callback
) {
  const rebuyEl = document.querySelector(rebuySelector);
  if (!rebuyEl) return;


  if (rebuyEl.children.length > 0) {
    callback(rebuyEl);
    return;
  }

  const observer = new MutationObserver(() => {
    if (rebuyEl.children.length > 0) {
      observer.disconnect();
      callback(rebuyEl);
    }
  });

  observer.observe(rebuyEl, {
    childList: true
  });
}


function hydrateCartUpsellFromRebuy({
  rebuySelector = '.cart-drawer.custom [data-rebuy-id]',
  upsellRootSelector = '.cart-drawer.custom .cart-upsell'
} = {}) {
  const rebuyRoot = document.querySelector(rebuySelector);
  console.log("Rebuy root", rebuyRoot);
  const upsellRoot = document.querySelector(upsellRootSelector);
    console.log("Upsell Root", upsellRoot);


  if (!rebuyRoot || !upsellRoot) return;

  /* -----------------------------
     GET DATA FROM REBUY
  ----------------------------- */

  const imageEl = rebuyRoot.querySelector('.rebuy-product-image img');
  console.log("Image", imageEl);
  const titleEl = rebuyRoot.querySelector('.rebuy-product-title a');
  const salePriceEl = rebuyRoot.querySelector(
    '.rebuy-product-price div .sale span:not(.sr-only)'
  );
  const comparePriceEl = rebuyRoot.querySelector(
    '.rebuy-product-price div .compare-at span:not(.sr-only)'
  );
  const variantOptionEl = rebuyRoot.querySelector(
    '.rebuy-select option.rebuy-product-options__option'
  );

  if (
    !imageEl ||
    !titleEl ||
    !salePriceEl ||
    !comparePriceEl ||
    !variantOptionEl
  ) return;

  const imageUrl = imageEl.src;
  const productTitle = titleEl.textContent.trim();
  const salePriceText = salePriceEl.textContent.trim();
  const comparePriceText = comparePriceEl.textContent.trim();
  const variantId = variantOptionEl.value;

  /* -----------------------------
     PRICE UTILS
  ----------------------------- */

  const normalizePrice = (price) =>
    parseFloat(price.replace(/[^0-9.]/g, ''));

  const salePrice = normalizePrice(salePriceText);
  const comparePrice = normalizePrice(comparePriceText);

  const discountPercent =
    comparePrice > salePrice
      ? Math.round(((comparePrice - salePrice) / comparePrice) * 100)
      : 0;

  /* -----------------------------
     UPDATE UPSELL
  ----------------------------- */

  const imageWrapper = upsellRoot.querySelector('.cart-upsell__image');
  const textEl = upsellRoot.querySelector('.cart-upsell__text');
  const buttonEl = upsellRoot.querySelector(
    '.cart-upsell__action button'
  );

  if (!imageWrapper || !textEl || !buttonEl) return;


  imageWrapper.innerHTML = '';
  const img = document.createElement('img');
  img.src = imageUrl;
  img.alt = productTitle;
  imageWrapper.appendChild(img);


  textEl.textContent = `Add ${productTitle} & Save ${discountPercent}%`;


  buttonEl.setAttribute('data-variant-id', variantId);
}

function hydrateProductUpsellFromRebuy({
  rebuySelector = '.product [data-rebuy-id]',
  upsellRootSelector = '.product-upsell'
} = {}) {
  const rebuyRoot = document.querySelector(rebuySelector);
  const upsellRoot = document.querySelector(upsellRootSelector);

  if (!rebuyRoot || !upsellRoot) return;

  const imageEl = rebuyRoot.querySelector('.rebuy-product-image img');
  const titleEl = rebuyRoot.querySelector('.rebuy-product-title a');
  const salePriceEl = rebuyRoot.querySelector(
    '.rebuy-product-price div .sale span:not(.sr-only)'
  );
  const comparePriceEl = rebuyRoot.querySelector(
    '.rebuy-product-price div .compare-at span:not(.sr-only)'
  );
  const variantOptionEl = rebuyRoot.querySelector(
    '.rebuy-select option.rebuy-product-options__option'
  );

  if (
    !imageEl ||
    !titleEl ||
    !salePriceEl ||
    !comparePriceEl ||
    !variantOptionEl
  ) return;

  const imageUrl = imageEl.src;
  const productTitle = titleEl.textContent.trim();
  const salePriceText = salePriceEl.textContent.trim();
  const comparePriceText = comparePriceEl.textContent.trim();
  const variantId = variantOptionEl.value;

  const normalizePrice = (price) =>
    parseFloat(price.replace(/[^0-9.]/g, ''));

  const salePrice = normalizePrice(salePriceText);
  const comparePrice = normalizePrice(comparePriceText);

  const discountPercent =
    comparePrice > salePrice
      ? Math.round(((comparePrice - salePrice) / comparePrice) * 100)
      : 0;

  const imageWrapper = upsellRoot.querySelector('.product-upsell__image');
  const textEl = upsellRoot.querySelector('.product-upsell__text');
  const buttonEl = upsellRoot.querySelector(
    '.product-upsell__action button'
  );

  if (!imageWrapper || !textEl || !buttonEl) return;

  imageWrapper.innerHTML = '';
  const img = document.createElement('img');
  img.src = imageUrl;
  img.alt = productTitle;
  imageWrapper.appendChild(img);

  textEl.textContent = `Add ${productTitle} & Save ${discountPercent}%`;

  buttonEl.setAttribute('data-variant-id', variantId);

  upsellRoot.style.display = 'block';
}


function resetRebuyWidget(selector) {
  const el = document.querySelector(selector);
  if (!el) return;

  el.removeAttribute('data-initialized');
  el.innerHTML = '';
}

function toggleCartUpsellBasedOnRebuy({
  rebuySelector = '.cart-drawer.custom [data-rebuy-id]',
  upsellSelector = '.cart-drawer.custom .cart-upsell',
  timeout = 1500
} = {}) {
  const upsellEl = document.querySelector(upsellSelector);
  if (!upsellEl) return;

  let found = false;

  const observer = new MutationObserver(() => {
    const rebuyEl = document.querySelector(rebuySelector);
    if (rebuyEl) {
      found = true;
      upsellEl.style.display = '';
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    if (!found) {
      upsellEl.style.display = 'none';
      observer.disconnect();
    }
  }, timeout);
}


document.addEventListener("DOMContentLoaded", () => {
  initAddToCartBox();
  document
    .querySelector("#cart-icon-bubble")
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });

  initAddToCartButtons();
  initMobileDrawer();
  initDrawerMegaMenu();

  const waitForBogos = setInterval(() => {
    if (window.FGSECOMAPP?.offers?.length) {
      clearInterval(waitForBogos);
      renderBogosGiftSlider();
    }
  }, 200);


observeBogosPopup();
observeBogosSlider();


whenRebuyHasChildren(
  '.cart-drawer.custom [data-rebuy-id]',
  () => {
    hydrateCartUpsellFromRebuy({
      rebuySelector: '.cart-drawer.custom [data-rebuy-id]'
    });
  }
);

toggleCartUpsellBasedOnRebuy();


  const waitBogos = setInterval(() => {
    if (window.FGSECOMAPP?.offers?.length) {
      clearInterval(waitBogos);
      renderBogosGiftSlider();
    }
  }, 200);
});

function reinitRebuyAndHydrate() {
  resetRebuyWidget('.cart-drawer.custom [data-rebuy-id]');

  window.Rebuy?.init?.();

  whenRebuyHasChildren(
    '.cart-drawer.custom [data-rebuy-id]',
    () => {
      hydrateCartUpsellFromRebuy({
        rebuySelector: '.cart-drawer.custom [data-rebuy-id]'
      });
    }
  );
}



/*document.addEventListener("fg-gifts:updated", () => {

  observeBogosSlider();
  setTimeout(() => {
   hydrateCartUpsellFromRebuy();
  }, 800);

});*/


document.addEventListener('facet:updated', () => {
  console.log("facet event fired!");
  initAddToCartBox();
  initAddToCartButtons();

});

document.addEventListener('filter:change', () => {
  initAddToCartBox();
  initAddToCartButtons();

});

document.addEventListener("gift-added", () => {

  setTimeout(() => {
    window.Rebuy.init();
  }, 300);

  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();

});

document.addEventListener("upsell:added", () => {
  setTimeout(() => {
    window.Rebuy.init();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});

document.addEventListener("cart-theme:updated", () => {
  console.log("cart theme updated");
  setTimeout(() => {
    window.Rebuy.init();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});
document.addEventListener("added:cart", () => {
  setTimeout(() => {
    window.Rebuy.init();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});
document.addEventListener("main:cart-added", () => {
  setTimeout(() => {
    window.Rebuy.init();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});

document.addEventListener("drawer:subscription-changed", () => {
  setTimeout(() => {
    window.Rebuy.init();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});

document.addEventListener("cart:updated:new", () => {
  setTimeout(() => {
    window.Rebuy?.init?.();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});

document.addEventListener("cart:updated:change", () => {
  setTimeout(() => {
    window.Rebuy?.init?.();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
});

document.addEventListener("fg-cart:auto-updated", () => {
  console.log("event fires now!");
  setTimeout(() => {
    window.Rebuy?.init?.();
  }, 300);
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
  observeBogosSlider();
  observeBogosPopup();
});


if (document.querySelector('.product')) {
  whenRebuyHasChildren(
    '.product [data-rebuy-id]',
    () => {
      hydrateProductUpsellFromRebuy({
        rebuySelector: '.product [data-rebuy-id]'
      });
    }
  );
} 

document.addEventListener("upsell:add", async e => {
  const { variantId, property, trigger } = e.detail;

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{
        id: Number(variantId),
        quantity: 1
      }]
    })
  });
refreshCartDrawer();

if (trigger && trigger.closest(".product-info-form")) {
  openCartDrawer();
}
  
});



export function onCartRerendered() {
  //console.log("cart DOM rerendered");

  window.Rebuy?.init?.();
  reinitRebuyAndHydrate();
  toggleCartUpsellBasedOnRebuy();
}

